import script from "./RandomJokes.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomJokes.vue?vue&type=script&setup=true&lang=js"

import "./RandomJokes.vue?vue&type=style&index=0&id=5febb380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5febb380"]])

export default __exports__